import { render, staticRenderFns } from "./AdminPricingPlanView.vue?vue&type=template&id=560b72e4"
import script from "./AdminPricingPlanView.vue?vue&type=script&lang=js"
export * from "./AdminPricingPlanView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gl-api/api.greenlists.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('560b72e4')) {
      api.createRecord('560b72e4', component.options)
    } else {
      api.reload('560b72e4', component.options)
    }
    module.hot.accept("./AdminPricingPlanView.vue?vue&type=template&id=560b72e4", function () {
      api.rerender('560b72e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/pages/AdminPricingPlanView.vue"
export default component.exports